(() => {
  'use strict';

  // Trova il wrapper della mappa
  const wrapper = document.querySelector('[data-farmeo-map-wrapper]');
  if (!wrapper) {
    console.warn('Farmeo Map: Wrapper element not found');
    return;
  }

  // Estrai configurazione e dati dal DOM
  let config;
  let polygonsData;
  let varietiesData;

  try {
    config = JSON.parse(wrapper.dataset.config || '{}');
    polygonsData = JSON.parse(wrapper.dataset.polygons || '[]');
    varietiesData = JSON.parse(wrapper.dataset.varieties || '{}');
  } catch (e) {
    console.error('Farmeo Map: Failed to parse configuration data', e);
    return;
  }

  // API key da metafield del negozio (sovrascrive il setting di sezione)
  config.google_maps_api_key = (wrapper.dataset.googleMapsKey || '').trim();

  // Elementi DOM
  const mapEl = wrapper.querySelector('.farmeo-map');
  const legendEl = wrapper.querySelector('[data-farmeo-map-legend]');
  const searchLocation = wrapper.querySelector('[data-search-location]');
  const searchBtn = wrapper.querySelector('[data-search-btn]');
  const filterColtura = wrapper.querySelector('[data-filter-coltura]');
  const filterVarieta = wrapper.querySelector('[data-filter_varieta]') || wrapper.querySelector('[data-filter-varieta]');

  // ✅ Lista prodotti sotto mappa (supporta sia #product-list che la tua section)
  function resolveProductListEl() {
    return (
      document.querySelector('.shopify-section.ui-test-product-list')
    );
  }

  // ✅ Intersezione bounds (Italia -> niente dateline edge-case)
  function boundsIntersects(a, b) {
    if (!a || !b) return false;
    const aSW = a.getSouthWest();
    const aNE = a.getNorthEast();
    const bSW = b.getSouthWest();
    const bNE = b.getNorthEast();

    return !(
      bSW.lat() > aNE.lat() ||
      bNE.lat() < aSW.lat() ||
      bSW.lng() > aNE.lng() ||
      bNE.lng() < aSW.lng()
    );
  }

  function getVisibleProductIdsInViewport() {
    const visible = new Set();
    if (!currentMap) return visible;

    const mapBounds = currentMap.getBounds();

    // ✅ Se i bounds non sono ancora disponibili (primo render), considera visibili tutti i poligoni renderizzati
    if (!mapBounds) {
      for (const poly of currentPolygons) {
        const pid = poly.__farmeoProductId;
        if (pid != null) visible.add(String(pid).trim());
      }
      return visible;
    }

    for (const poly of currentPolygons) {
      const pid = poly.__farmeoProductId;
      const pBounds = poly.__farmeoBounds;
      if (pid == null || !pBounds) continue;

      if (boundsIntersects(mapBounds, pBounds)) {
        visible.add(String(pid).trim());
      }
    }

    return visible;
  }

  function syncProductListWithMapViewport() {
    const listEl = resolveProductListEl();
    if (!listEl) return;

    const visibleIds = getVisibleProductIdsInViewport();

    // ✅ Nel tuo tema i prodotti sono <product-card-link ...>
    const links = listEl.querySelectorAll(
      'product-card-link[data-product-id], .product-card-link[data-product-id]'
    );

     links.forEach((el) => {
      const id = String(el.getAttribute('data-product-id') || '').trim();

      // ✅ padre diretto
      const card = el.parentElement || el;

      const shouldShow = visibleIds.size > 0 && visibleIds.has(id);

      card.style.display = shouldShow ? '' : 'none';
    });
  }

  // Variabile per l'autocomplete
  let autocomplete = null;

  if (!mapEl) {
    console.warn('Farmeo Map: Map element not found');
    return;
  }

  // Stato corrente dei filtri
  const currentFilters = {
    coltura: '',
    varieta: ''
  };

  // Colori per coltura
  const colturaColors = {
    ARANCIO: '#FF6B35',
    LIMONE: '#F7DC6F',
    CLEMENTINE: '#82E0AA',
    MANDARINO: '#F1948A'
  };

  // Elementi legenda
  const legendItems = [
    { key: 'ARANCIO', label: 'Arancio', color: colturaColors.ARANCIO },
    { key: 'LIMONE', label: 'Limone', color: colturaColors.LIMONE },
    { key: 'CLEMENTINE', label: 'Clementine', color: colturaColors.CLEMENTINE },
    { key: 'MANDARINO', label: 'Mandarino', color: colturaColors.MANDARINO }
  ];

  // Funzioni di utilità
  function normalizeColtura(value) {
    if (!value) return '';
    return String(value).trim().toUpperCase();
  }

  function getColturaColor(coltura) {
    const key = normalizeColtura(coltura);
    return colturaColors[key] || config.default_color || '#00A3FF';
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatVarieta(varieta) {
    if (!varieta) return '';
    if (Array.isArray(varieta)) {
      return varieta.map(v => String(v).trim()).filter(Boolean).join(', ');
    }
    return String(varieta).trim();
  }

  // Funzione di geocoding per ricerca località
  function searchGeographicLocation(query) {
    if (!query.trim() || !window.google?.maps?.Geocoder) return;

    const geocoder = new google.maps.Geocoder();

    // Migliora la query per risultati italiani più precisi
    let searchQuery = query.trim();
    if (!searchQuery.toLowerCase().includes('italia') &&
        !searchQuery.toLowerCase().includes('italy')) {
      searchQuery += ', Italia';
    }

    geocoder.geocode({
      address: searchQuery,
      componentRestrictions: { country: 'IT' } // Solo risultati italiani
    }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        const place = results[0];

        // Usa la stessa logica di handlePlaceSelection
        const types = place.types || [];
        let zoom = 10;

        if (types.includes('locality') || types.includes('administrative_area_level_3')) {
          zoom = 12;
        } else if (types.includes('administrative_area_level_1')) {
          zoom = 8;
        }

        currentMap.setCenter(location);
        currentMap.setZoom(zoom);

        showLocationMarker(location, query, zoom);
      } else {
        console.warn('Geocoding failed for:', query);
        // Mostra un messaggio di errore all'utente
        showSearchError('Località non trovata. Prova con il nome di una provincia o città italiana.');
      }
    });
  }

  // Inizializza autocomplete per ricerca località
  function initAutocomplete() {
    if (!window.google?.maps?.places?.Autocomplete) return;

    autocomplete = new google.maps.places.Autocomplete(searchLocation, {
      componentRestrictions: { country: 'IT' }, // Solo Italia
      fields: ['geometry', 'name', 'types'],
      types: ['(regions)'] // Province e città
    });

    // Quando l'utente seleziona un suggerimento
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        handlePlaceSelection(place);
      }
    });
  }

  function handlePlaceSelection(place) {
    const location = place.geometry.location;
    const types = place.types || [];

    // Determina il livello di zoom basato sul tipo di località
    let zoom = 10; // default per province

    if (types.includes('locality') || types.includes('administrative_area_level_3')) {
      zoom = 12; // città
    } else if (types.includes('administrative_area_level_1')) {
      zoom = 8; // regione
    } else if (types.includes('country')) {
      zoom = 6; // Italia
    }

    currentMap.setCenter(location);
    currentMap.setZoom(zoom);

    // Marker migliorato con info sulla località
    showLocationMarker(location, place.name, zoom);
  }

  function showLocationMarker(location, title, zoom) {
    if (currentSearchMarker) {
      currentSearchMarker.setMap(null);
    }

    currentSearchMarker = new google.maps.Marker({
      position: location,
      map: currentMap,
      title: title,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: '#ef4444',
        fillOpacity: 0.9,
        strokeColor: '#ffffff',
        strokeWeight: 2
      }
    });

    // Rimuovi marker dopo timeout più lungo per località selezionate
    const timeout = zoom > 10 ? 5000 : 3000; // Più tempo per città
    setTimeout(() => {
      if (currentSearchMarker) {
        currentSearchMarker.setMap(null);
        currentSearchMarker = null;
      }
    }, timeout);
  }

  // Mostra messaggio di errore per ricerche fallite
  function showSearchError(message) {
    // Rimuovi eventuali errori precedenti
    const existingError = wrapper.querySelector('.farmeo-search-error');
    if (existingError) {
      existingError.remove();
    }

    // Crea nuovo messaggio di errore
    const errorDiv = document.createElement('div');
    errorDiv.className = 'farmeo-search-error';
    errorDiv.textContent = message;
    errorDiv.style.cssText = `
      position: absolute;
      top: 60px;
      left: 20px;
      background: #fee2e2;
      color: #dc2626;
      padding: 12px 16px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 1000;
      max-width: 300px;
      font-size: 14px;
      line-height: 1.4;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    `;

    wrapper.appendChild(errorDiv);

    // Rimuovi automaticamente dopo 4 secondi
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 4000);
  }

  // Filtraggio dati (solo coltura e varietà)
  function filterPolygons() {
    return polygonsData.filter(item => {
      const matchesColtura = !currentFilters.coltura ||
        item.coltura === currentFilters.coltura;

      let matchesVarieta = true;
      if (currentFilters.varieta) {
        if (Array.isArray(item.varieta)) {
          matchesVarieta = item.varieta.some(v => String(v).trim() === currentFilters.varieta);
        } else if (item.varieta) {
          matchesVarieta = String(item.varieta).trim() === currentFilters.varieta;
        } else {
          matchesVarieta = false;
        }
      }

      return matchesColtura && matchesVarieta;
    });
  }

  // Popola opzioni varietà basate sulla coltura selezionata
  function populateVarietaOptions(selectedColtura = '') {
    if (!filterVarieta) return;

    // Se nessuna coltura selezionata, nascondi il filtro
    if (!selectedColtura) {
      filterVarieta.hidden = true;
      filterVarieta.innerHTML = '<option value="">Tutte le varietà</option>';
      return;
    }

    // Ottieni le varietà per la coltura selezionata
    const colturaVarieta = varietiesData[selectedColtura] || [];

    // Se c'è una sola varietà o nessuna, nascondi il filtro
    if (colturaVarieta.length <= 1) {
      filterVarieta.hidden = true;
      filterVarieta.innerHTML = '<option value="">Tutte le varietà</option>';
      return;
    }

    // Mostra il filtro e popola con le varietà della coltura selezionata
    filterVarieta.hidden = false;
    const options = ['<option value="">Tutte le varietà</option>'];

    colturaVarieta.sort().forEach(varieta => {
      options.push(`<option value="${escapeHtml(varieta)}">${escapeHtml(varieta)}</option>`);
    });

    filterVarieta.innerHTML = options.join('');
  }

  // Gestione eventi
  function setupEventListeners() {
    // Ricerca geografica con autocomplete
    if (searchLocation) {
      // Inizializza autocomplete quando Google Maps è caricato
      loadGoogleMaps().then(() => {
        initAutocomplete();
      });

      const performSearch = () => {
        const query = searchLocation.value.trim();
        if (query) {
          searchGeographicLocation(query);
        }
      };

      // Ricerca su pulsante (se presente)
      if (searchBtn) {
        searchBtn.addEventListener('click', performSearch);
      }

      // Ricerca su Enter
      searchLocation.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          performSearch();
        }
      });
    }

    // Filtri coltura e varietà
    if (filterColtura) {
      filterColtura.addEventListener('change', (e) => {
        currentFilters.coltura = e.target.value;
        currentFilters.varieta = ''; // Reset filtro varietà quando cambia coltura
        updateMap();
        populateVarietaOptions(e.target.value);
      });
    }

    if (filterVarieta) {
      filterVarieta.addEventListener('change', (e) => {
        currentFilters.varieta = e.target.value;
        updateMap();
      });
    }
  }

  // Conversione coordinate poligono
  function convertPolygon(polygonString) {
    if (!polygonString || typeof polygonString !== 'string') return [];

    const cleaned = polygonString.trim().replace(/,+$/, '');
    if (!cleaned) return [];

    const parts = cleaned.split(' ').map(s => s.trim()).filter(Boolean);
    const coords = [];

    for (const part of parts) {
      const pair = part.split(',');
      if (pair.length >= 2) {
        const lng = parseFloat(pair[0]);
        const lat = parseFloat(pair[1]);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          coords.push({ lat, lng });
        }
      }
    }

    return coords;
  }

  function getPolygonCenter(polygon) {
    if (!polygon || !polygon.length) return null;
    let latSum = 0, lngSum = 0;
    for (const point of polygon) {
      latSum += point.lat;
      lngSum += point.lng;
    }
    return { lat: latSum / polygon.length, lng: lngSum / polygon.length };
  }

  // Rendering legenda
  function renderLegend() {
    if (!config.show_legend || !legendEl) return;

    const rows = legendItems.map(item =>
      `<div class="farmeo-map-legend__row">
        <span class="farmeo-map-legend__swatch" style="background: ${escapeHtml(item.color)}"></span>
        <span>${escapeHtml(item.label)}</span>
      </div>`
    ).join('');

    legendEl.innerHTML = `<div class="farmeo-map-legend__title">Legenda</div>${rows}`;
    legendEl.hidden = false;
  }

  // Caricamento Google Maps
  let googleMapsPromise = null;

  function loadGoogleMaps() {
    if (window.google && window.google.maps) return Promise.resolve();

    if (!googleMapsPromise) {
      googleMapsPromise = new Promise((resolve, reject) => {
        if (!config.google_maps_api_key) {
          reject(new Error('Google Maps API key not configured'));
          return;
        }

        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(config.google_maps_api_key)}&libraries=places&v=weekly`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Google Maps'));
        document.head.appendChild(script);
      });
    }

    return googleMapsPromise;
  }

  // Rendering mappa
  let currentMap = null;
  let currentPolygons = [];
  let currentSearchMarker = null; // Marker per ricerche geografiche

  function clearMap() {
    currentPolygons.forEach(polygon => polygon.setMap(null));
    currentPolygons = [];
  }

  function renderMap(filteredPolygons) {
    if (!currentMap) return;

    clearMap();

    if (!filteredPolygons.length) {
      mapEl.innerHTML = `<div style="padding: 20px; text-align: center; color: #666;">
        ${escapeHtml(config.no_polygon_message || 'Nessun poligono disponibile con i filtri selezionati.')}
      </div>`;
      return;
    }

    const bounds = new google.maps.LatLngBounds();
    const infoWindow = new google.maps.InfoWindow({ maxWidth: 350 });

    for (const item of filteredPolygons) {
      const polygonCoords = convertPolygon(item.polygon);
      if (!polygonCoords.length) continue;

      // ✅ Bounds del poligono (per capire se è nel viewport)
      const polyBounds = new google.maps.LatLngBounds();
      polygonCoords.forEach(coord => polyBounds.extend(coord));

      const polygon = new google.maps.Polygon({
        paths: polygonCoords,
        strokeColor: getColturaColor(item.coltura),
        strokeOpacity: (config.default_stroke_opacity || 80) / 100,
        strokeWeight: config.default_stroke_weight || 3,
        fillColor: getColturaColor(item.coltura),
        fillOpacity: (config.default_fill_opacity || 35) / 100
      });

      // ✅ Metadati per sync lista prodotti
      polygon.__farmeoProductId = item.product_id;
      polygon.__farmeoBounds = polyBounds;

      polygon.setMap(currentMap);
      currentPolygons.push(polygon);

      // Estendi bounds
      polygonCoords.forEach(coord => bounds.extend(coord));

      // Info window
      polygon.addListener('click', (event) => {
        const coltura = String(item.coltura || '').trim();
        const varieta = formatVarieta(item.varieta);

        let content = `<div class="farmeo-crop-label">`;
        if (coltura) {
          content += `<div class="farmeo-crop-label__title">${escapeHtml(coltura)}</div>`;
        }
        if (varieta) {
          content += `<div class="farmeo-crop-label__text"><strong>Varietà:</strong> ${escapeHtml(varieta)}</div>`;
        }
        if (item.product_title) {
          content += `<div class="farmeo-crop-label__text"><strong>Azienda:</strong> ${escapeHtml(item.product_title)}</div>`;
        }
        if (item.product_url) {
          const productUrl = escapeHtml(item.product_url);
          content += `<div class="farmeo-crop-label__actions">
            <a class="farmeo-crop-label__button" href="${productUrl}" aria-label="Vai alla pagina prodotto">Vai al prodotto</a>
          </div>`;
        }
        content += `</div>`;

        infoWindow.setContent(content);
        infoWindow.setPosition(event.latLng || getPolygonCenter(polygonCoords) || currentMap.getCenter());
        infoWindow.open({ map: currentMap });
      });
    }

    if (config.fit_bounds && currentPolygons.length) {
      currentMap.fitBounds(bounds);
      // ✅ dopo il fitBounds i bounds cambiano: aspetta idle per sync corretto
      google.maps.event.addListenerOnce(currentMap, 'idle', syncProductListWithMapViewport);
    } else {
      syncProductListWithMapViewport();
    }
  }

  // Aggiornamento mappa
  function updateMap() {
    const filteredPolygons = filterPolygons();
    renderMap(filteredPolygons);
  }

  // Inizializzazione
  function initMap() {
    const filteredPolygons = filterPolygons();

    if (!filteredPolygons.length) {
      mapEl.innerHTML = `<div style="padding: 20px; text-align: center; color: #666;">
        ${escapeHtml(config.no_polygon_message || 'Nessun poligono disponibile.')}
      </div>`;
      return;
    }

    // Centro iniziale
    let center = {
      lat: parseFloat(config.center_lat || '41.9102088'),
      lng: parseFloat(config.center_lng || '12.3711927')
    };

    // Se ci sono poligoni, usa il centro del primo
    if (filteredPolygons.length > 0) {
      const firstPolygon = convertPolygon(filteredPolygons[0].polygon);
      const polygonCenter = getPolygonCenter(firstPolygon);
      if (polygonCenter) center = polygonCenter;
    }

    currentMap = new google.maps.Map(mapEl, {
      zoom: config.zoom || 17,
      center: center,
      mapTypeId: config.map_type || 'satellite',
      disableDefaultUI: config.disable_default_ui || false,
      gestureHandling: config.gesture_handling || 'auto'
    });

    // ✅ Aggiorna lista prodotti quando l’utente zoomma o trascina
    currentMap.addListener('idle', syncProductListWithMapViewport);

    // Imposta altezza
    if (config.height) {
      mapEl.style.height = `${config.height}vh`;
    }

    renderLegend();
    renderMap(filteredPolygons);
  }

  // Avvio applicazione
  function init() {
    setupEventListeners();
    populateVarietaOptions();

    loadGoogleMaps()
      .then(() => initMap())
      .catch((error) => {
        console.error('Farmeo Map initialization failed:', error);
        mapEl.innerHTML = `<div style="padding: 20px; text-align: center; color: #d32f2f;">
          ${escapeHtml(config.error_message || 'Impossibile caricare la mappa.')}
        </div>`;
      });
  }

  // Avvia l'applicazione
  init();
})();